import {
    ACC_CORP_LOGO_VIEW,
    ACC_CORP_LOGO_VIEW_FAIL,
    ACC_CORP_LOGO_VIEW_REFRESH,
    ACC_CORP_LOGO_VIEW_RESET,
    ACC_CORP_LOGO_VIEW_SUCCESS,
} from './constants';

// 企业logo
export const accountCorpLogoViewRefresh = () => ({
    type: ACC_CORP_LOGO_VIEW_REFRESH,
    payload: null,
});
export const accountCorpLogoViewReset = () => ({
    type: ACC_CORP_LOGO_VIEW_RESET,
    payload: null,
});
export const accountCorpLogoView = ({corpId}) => ({
    type: ACC_CORP_LOGO_VIEW,
    payload: {corpId},
});
export const accountCorpLogoViewSuccess = (data) => ({
    type: ACC_CORP_LOGO_VIEW_SUCCESS,
    payload: data,
});
export const accountCorpLogoViewFail = (data) => ({
    type: ACC_CORP_LOGO_VIEW_FAIL,
    payload: data,
});